








































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { BButton, BForm, BFormCheckbox, BFormGroup, BFormInput } from 'bootstrap-vue';

import LoadingSpinner from '@reciprocity/loading-spinner';
import { loadSAMLSettings, saveSAMLSettings } from '@/utils/crudActions';

export default Vue.extend({
  name: 'SAMLSettingsPage',
  components: {
    BButton,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    LoadingSpinner,
  },
  data() {
    return {
      attemptedSave: <boolean>false,
      samlSettings: <object | null>null,
      loading: <boolean>true,
    };
  },
  computed: {
    groupNamesValid(): boolean {
      const valid =
        this.samlSettings.contributorGroup !== '' &&
        this.samlSettings.readerGroup !== '' &&
        this.samlSettings.editorGroup !== '' &&
        this.samlSettings.administratorGroup !== '';
      return valid;
    },
    ...mapGetters(['csrfToken', 'routes']),
  },
  async created() {
    this.setPageTitle({ title: 'SAML Settings' });
    try {
      this.samlSettings = await this.loadSAMLSettings(this.routes.samlSettings);
    } catch (error) {
      this.showAlert({
        type: 'error',
        message: error.message,
      });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
    }),
    async save() {
      this.attemptedSave = true;

      if ((this.$refs.form as HTMLFormElement).checkValidity() === false) {
        return;
      }

      try {
        await this.saveSAMLSettings({
          url: this.routes.samlSettings,
          data: this.samlSettings,
          csrf: this.csrfToken,
        });
        this.showAlert({
          type: 'success',
          message: 'Settings saved successfully',
        });
      } catch (error) {
        this.showAlert(error);
      }
    },
    loadSAMLSettings,
    saveSAMLSettings,
  },
});
